function bundle() {
  let bundles = document.querySelectorAll('.bundle');
  if (!bundles.length) return;

  bundles.forEach(bundle => {
    let bundleToggle = bundle.querySelector('.bundle__cart--title');
    let add_to_bundles = bundle.querySelectorAll('.add-to-bundle');
    let bundleCart = bundle.querySelector('.bundle__cart--body table');

    let subtotalElement = bundle.querySelector('.bundle-subtotal .bundle-sub-amount');
    let discountWrap = bundle.querySelector('.bundle-discount');
    let discountElement = bundle.querySelector('.bundle-discount .bundle-discount-amount');
    let totalElements = bundle.querySelectorAll('.bundle-total-amount');

    let submitBtn = bundle.querySelector('.product-form__submit');
    let errorBox = bundle.querySelector('.bundle-error');

    let offerTextEl = bundle.querySelectorAll('.current-eligible-offer');

    let discountProductData = bundle.querySelector('.bundle__cart--footer')?.dataset.discountProduct || "";
    let discountCartData = bundle.querySelector('.bundle__cart--footer')?.dataset.discountCart || "";

    let productDiscountRules = [];
    let cartDiscountRules = [];

    /* --------------------------
       DISCOUNT PARSER
    -----------------------------*/
    function parseDiscountJSON(str) {
      try {
        if (!str.includes('{')) {
          return str.split(',').map(item => {
            let [key, val] = item.split(':');
            return { key: parseFloat(key), val: parseFloat(val) };
          });
        }

        let formatted = str
          .replace(/([{,]\s*)(\d+)\s*:/g, '$1"$2":')
          .replace(/'/g, '"');

        return JSON.parse(formatted).map(obj => ({
          key: parseFloat(Object.keys(obj)[0]),
          val: parseFloat(Object.values(obj)[0])
        }));
      } catch (e) {
        console.error('Invalid discount data:', str);
        return [];
      }
    }

    if (discountProductData) productDiscountRules = parseDiscountJSON(discountProductData);
    if (discountCartData) cartDiscountRules = parseDiscountJSON(discountCartData);

    /* --------------------------
       MOBILE TOGGLE
    -----------------------------*/
    if (window.matchMedia('(max-width: 768px)').matches) {
      bundleToggle?.addEventListener('click', () => {
        bundle.classList.toggle('show-products');
      });
    }

    /* --------------------------
       QUANTITY EVENTS
    -----------------------------*/
    function attachQtyEvents(row) {
      let minusBtn = row.querySelector('.quantity__button[name="minus"]');
      let plusBtn = row.querySelector('.quantity__button[name="plus"]');
      let qtyInput = row.querySelector('.quantity__input');

      if (!qtyInput) return;

      minusBtn?.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
        calculateTotal();
      });

      plusBtn?.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
        calculateTotal();
      });

      qtyInput.addEventListener('input', () => {
        if (parseInt(qtyInput.value) < 1) qtyInput.value = 1;
        calculateTotal();
      });
    }

    bundleCart.querySelectorAll('.bundle-cart-item').forEach(attachQtyEvents);

    /* --------------------------
       MAIN TOTAL CALCULATION
    -----------------------------*/
    function calculateTotal() {
      let rows = bundleCart.querySelectorAll('.bundle-cart-item');
      let subtotal = 0;
      let productCount = 0;

      rows.forEach(row => {
        if (row.style.display === 'none') return;

        let priceEl = row.querySelector('.cart-item__final-price');
        let qtyEl = row.querySelector('.quantity__input');

        let price = parseFloat((priceEl?.innerText || '').replace(/[^\d.]/g, '')) || 0;
        let qty = parseInt(qtyEl?.value) || 1;

        subtotal += price * qty;
        productCount += qty;
      });

      /* --------------------------
         BUNDLE ITEM COUNT MESSAGE
      -----------------------------*/
      if (offerTextEl.length) {
        offerTextEl.forEach(el => {
          if (productCount > 0) {
            el.textContent = `${productCount} item${productCount > 1 ? 's' : ''} in your bundle`;
          } else {
            el.textContent = `Add items to your bundle`;
          }
        });
      }

      /* --------------------------
         DISCOUNT CALCULATION
      -----------------------------*/
      let discountPercent = 0;
      let discountValue = 0;

      if (productDiscountRules.length) {
        productDiscountRules.forEach(rule => {
          if (productCount >= rule.key) discountPercent = rule.val;
        });
      } else if (cartDiscountRules.length) {
        cartDiscountRules.forEach(rule => {
          if (subtotal >= rule.key) discountPercent = rule.val;
        });
      }

      discountValue = subtotal * (discountPercent / 100);
      let finalTotal = subtotal - discountValue;

      subtotalElement.textContent =
        `₹${subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

      if (discountPercent > 0) {
        discountWrap?.classList.remove('hide');
        discountElement.textContent =
          `-${discountPercent}% (₹${discountValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })})`;
      } else {
        discountWrap?.classList.add('hide');
      }

      totalElements.forEach(el => {
        el.textContent =
          `₹${finalTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
      });
    }

    /* --------------------------
       REMOVE PRODUCT
    -----------------------------*/
    function attachRemoveEvents() {
      bundleCart.querySelectorAll('.bundle-item-remove').forEach(btn => {
        btn.onclick = () => {
          btn.closest('.bundle-cart-item')?.remove();
          calculateTotal();
        };
      });
    }

    /* --------------------------
       ADD PRODUCT
    -----------------------------*/
    add_to_bundles.forEach(btn => {
      btn.addEventListener('click', function () {
        let product = this.closest('.product-card-wrapper')
          ?.querySelector('.bundle-cart-item');

        if (!product) return;

        let clone = product.cloneNode(true);
        clone.style.display = '';
        bundleCart.prepend(clone);

        this.setAttribute('disabled', true);
        this.innerText = window.matchMedia('(max-width: 768px)').matches
          ? 'Added'
          : 'Added to Set';

        attachQtyEvents(clone);
        attachRemoveEvents();
        calculateTotal();
      });
    });

    /* --------------------------
       PREVENT EMPTY SUBMIT
    -----------------------------*/
    submitBtn?.addEventListener('click', e => {
      let items = bundleCart.querySelectorAll(
        '.bundle-cart-item:not([style*="display: none"])'
      );

      if (!items.length) {
        e.preventDefault();
        errorBox.style.display = 'block';
      } else {
        errorBox.style.display = 'none';
      }
    });

    calculateTotal();
  });
}

document.addEventListener('DOMContentLoaded', bundle);